import { Business } from 'model';
import { BusinessHeader } from '../components/BusinessHeader';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import styles from './BusinessDetail.module.css';
import { ClaimBusinessBanner } from '../components/ClaimBusinessBanner';
import { RealUserOnly } from './admin/RealUserOnly';
import { BusinessDetailToolbar } from '../components/BusinessDetailToolbar';
import { BusinessContextMenu } from '../components/BusinessContextMenu';
import { useUserHasRole } from '../hooks/useUserHasRole.js';
import { BusinessDetails } from '../components/BusinessDetails.js';
import { BusinessStatusBanner } from '../components/BusinessStatusBanner.js';

export const BusinessDetailBody = ({
	business,
	showToolbar,
	showClaim
}: {
	business: Business;
	showToolbar?: boolean;
	showClaim?: boolean;
}) => {
	const isAdmin = useUserHasRole('admin');
	return (
		<div className="scrollContent" style={{ paddingTop: 0 }}>
			<BusinessHeader business={business} />
			<div className={sharedStyles.pageContainer}>
				<div className={styles.businessTitleContainer}>
					<h2>
						<span data-testid="businessName">{business?.name}</span>
						{showToolbar && <BusinessContextMenu business={business} context="detail" />}
					</h2>
				</div>
				<BusinessStatusBanner business={business} />
				<div className={sharedStyles.pageDescription} data-testid="businessDescription">
					{business?.description}
				</div>
				{showToolbar && <BusinessDetailToolbar business={business} />}
				<BusinessDetails business={business} />
				{showClaim && business.claimStatus === 'unclaimed' && !isAdmin && (
					<RealUserOnly>
						<ClaimBusinessBanner business={business} />
					</RealUserOnly>
				)}
			</div>
		</div>
	);
};
